/* =========================================================
   J'ADORE — podstrony marek: doladowanie WSZYSTKICH produktow.
   Liquid renderuje pierwsze 50 (twardy limit Shopify na collection.products
   bez paginate). Reszte dociagamy z /collections/<handle>/products.json.
   Karta 1:1 jak w Liquidzie. Dodawanie do koszyka przez window.jadAdd.
   ========================================================= */
(function () {
  var grid = document.querySelector('.mk-products-grid[data-brand]');
  var btn = document.getElementById('mkMore');
  if (!grid || !btn) return;

  var handle = grid.getAttribute('data-brand') || '';
  var total = parseInt(grid.getAttribute('data-total'), 10) || 0;
  var label = grid.getAttribute('data-label') || '';
  var page = 1;
  var PER = 50;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function zl(v) {
    var n = parseFloat(v) || 0;
    var s = n.toFixed(2).replace('.', ',');
    return s.replace(/\B(?=(\d{3})+(?=,))/g, ' ') + ' zł';
  }
  function shown() { return grid.querySelectorAll('.vcard').length; }

  function card(p) {
    var v = (p.variants && p.variants[0]) || {};
    var img = (p.images && p.images[0] && p.images[0].src) || '';
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=700';
    var promo = v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price);
    var url = '/products/' + p.handle;

    var d = document.createElement('div');
    d.className = 'vcard';
    d.setAttribute('style', 'background:#fff;border:1px solid #ECE6D8;border-radius:16px;overflow:hidden;display:flex;flex-direction:column');
    d.innerHTML =
      '<a href="' + esc(url) + '" style="position:relative;aspect-ratio:4/5;background:#F1F0EC;overflow:hidden;display:block">' +
        (promo ? '<span style="position:absolute;top:14px;left:14px;z-index:3;background:linear-gradient(135deg,#7E2433,#4A1019);color:#F4E7E4;font-size:10px;font-weight:500;letter-spacing:1px;text-transform:uppercase;padding:5px 11px;border-radius:20px">Promocja</span>' : '') +
        '<div class="pzoom" style="position:absolute;inset:0">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" style="width:100%;height:100%;object-fit:contain;background:#fff;display:block">' : '') +
        '</div>' +
      '</a>' +
      '<div style="padding:20px;display:flex;flex-direction:column;flex:1">' +
        '<div style="font-size:9.5px;letter-spacing:2px;text-transform:uppercase;color:#A9823C;margin-bottom:7px">' + esc(label) + ' · ' + esc(p.product_type || 'Pielęgnacja') + '</div>' +
        '<a href="' + esc(url) + '" style="text-decoration:none"><b style="font-family:Cormorant,serif;font-size:20px;font-weight:600;color:#1E1B16;line-height:1.14;display:block;margin-bottom:14px">' + esc(p.title) + '</b></a>' +
        '<div style="margin-top:auto;display:flex;align-items:center;justify-content:space-between;gap:10px">' +
          '<div style="display:flex;align-items:baseline;gap:8px">' +
            '<span style="font-family:Cormorant,serif;font-size:22px;font-weight:600;color:#1E1B16">' + zl(v.price) + '</span>' +
            (promo ? '<s style="font-size:12.5px;color:#C2BBAC">' + zl(v.compare_at_price) + '</s>' : '') +
          '</div>' +
          '<button class="addbtn" aria-label="Dodaj do koszyka" style="width:42px;height:42px;flex-shrink:0;border:1px solid #E2DCCC;border-radius:9px;background:#1E1B16;color:#F2E9D6;cursor:pointer;display:flex;align-items:center;justify-content:center"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 5v14M5 12h14"/></svg></button>' +
        '</div>' +
      '</div>';

    var b = d.querySelector('.addbtn');
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (window.jadAdd) window.jadAdd(v.id, b);
    });
    return d;
  }

  function label_rest() {
    var r = total - shown();
    return r > 0 ? 'Pokaż więcej (' + r + ')' : '';
  }

  btn.addEventListener('click', function () {
    var prev = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Ładowanie…';
    page += 1;
    fetch('/collections/' + handle + '/products.json?limit=' + PER + '&page=' + page)
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (d) {
        var list = (d && d.products) || [];
        var frag = document.createDocumentFragment();
        list.forEach(function (p) { frag.appendChild(card(p)); });
        grid.appendChild(frag);
        if (!list.length || shown() >= total) {
          if (btn.parentNode) btn.parentNode.removeChild(btn);
        } else {
          btn.disabled = false;
          btn.textContent = label_rest();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = prev;
      });
  });
})();
